import { render, staticRenderFns } from "./ProductSingleOrganization.vue?vue&type=template&id=19dc33dd&"
import script from "./ProductSingleOrganization.vue?vue&type=script&lang=js&"
export * from "./ProductSingleOrganization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports